import { render } from "./Nombre_resultat_afficher.vue?vue&type=template&id=21bbedba"
import script from "./Nombre_resultat_afficher.vue?vue&type=script&lang=js"
export * from "./Nombre_resultat_afficher.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Alexandre-OlivierRenaud/formateurs-autorises/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__